export default __webpack_public_path__ + "static/serious-9c9a6ae695837950b1c0d3d5b4715db9.svg";